export default "__VITE_ASSET__V2AaOjtf__"